export default "__VITE_PUBLIC_ASSET__8bb97687__"